module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.needsCityAccountForm) ? _c('div', [_c('br'), _vm._v(" "), _c('h4', {
    staticClass: "pt-4"
  }, [_vm._v("Required Bountiful Utility information")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "max-width": "640px"
    }
  }, [_vm._v("\n      Bountiful Fiber customers must enter their Account Number and Customer ID from their "), _vm._m(0), _vm._v(".\n      These numbers can be found on your "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "id": "utility-bill-btn"
    },
    on: {
      "click": function($event) {
        _vm.show_utility_bill = !_vm.show_utility_bill
      }
    }
  }, [_c('b', [_vm._v("utility bill")])]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('sample-utility-bill')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_utility_bill),
      expression: "show_utility_bill"
    }],
    attrs: {
      "id": "sample-utility-bill"
    }
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xmweb3/btfl-utility-sample.png",
      "alt": "Sample Utility Bill"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n        Bountiful Utility Account Number"), _c('br'), _vm._v(" "), _c('xm-input', {
    staticClass: "mb-3",
    attrs: {
      "pattern": _vm.city_account_id_regex,
      "required": "",
      "error": "Enter account ID",
      "maxlength": 30
    },
    model: {
      value: (_vm.form_data.city_account_id),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "city_account_id", $$v)
      },
      expression: "form_data.city_account_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n        Bountiful Utility Customer ID"), _c('br'), _vm._v(" "), _c('xm-input', {
    staticClass: "mb-3",
    attrs: {
      "pattern": _vm.city_customer_id_regex,
      "required": "",
      "error": "Enter a valid integer",
      "maxlength": 10
    },
    model: {
      value: (_vm.form_data.city_customer_id),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "city_customer_id", $$v)
      },
      expression: "form_data.city_customer_id"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.bountifulutah.gov/Utilities1",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("Bountiful Utility account")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec0c6ec2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/UtopiaResidential.vue
// module id = 1351
// module chunks = 16